import type { User } from "@/types";

export function isSystemOwner(user: User | null | undefined): boolean {
  if (!user) return false;

  const identity = (user.username ?? user.email ?? "").trim().toLowerCase();

  return (
    identity === "allmight" ||
    identity === "allmight@innsight.systems"
  );
}
